import { useCallback, useEffect, useState } from 'react'
import { getAllItemStates, getLocalCounts, getVocabularyGroups, getWeeklyLocalCounts, stateChangedEvent } from '../data/db'

function useLocalQuery<T>(loader: () => Promise<T>, initialData: T) {
  const [data, setData] = useState(initialData)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>()
  const refresh = useCallback(async () => {
    try {
      setError(undefined)
      setData(await loader())
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : '无法读取本地数据')
    } finally {
      setLoading(false)
    }
  }, [loader])

  useEffect(() => {
    void refresh()
    window.addEventListener(stateChangedEvent, refresh)
    return () => window.removeEventListener(stateChangedEvent, refresh)
  }, [refresh])

  return { data, loading, error, refresh }
}

export const useItemStatesData = () => useLocalQuery(getAllItemStates, [])
export const useVocabularyData = () => useLocalQuery(getVocabularyGroups, [])
export const useWeeklyOverview = (start: string, end: string) => {
  const loader = useCallback(() => getWeeklyLocalCounts(start, end), [end, start])
  return useLocalQuery(loader, { openedItems: 0, vocabulary: 0, reviewableVocabulary: 0 })
}
export const useLocalOverview = () => useLocalQuery(getLocalCounts, {
  savedItems: 0,
  feedbackItems: 0,
  readingRecords: 0,
  vocabulary: 0,
  pendingVocabulary: 0,
  reviewedVocabulary: 0,
})
